import {z as zod} from "zod";
import {integerZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type MediaLibraryWorkspaceCapabilityConfiguration = {
    allowedMimeTypes?: Array<string>;
    maxFileSizeBytes?: number;
    maxFolderDepth?: number;
};

export const mediaLibraryWorkspaceCapabilityConfigurationValidator: zod.ZodType<MediaLibraryWorkspaceCapabilityConfiguration> =
    zod.preprocess(
        (value) => value ?? {},
        zod.object({
            allowedMimeTypes: zod.array(zod.string()).optional(),
            maxFileSizeBytes: integerZodValidator.optional(),
            maxFolderDepth: integerZodValidator.optional(),
        }),
    );
